import React, { useRef, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { breakpoint, paramsjs } from 'helpers';
import { useLocation } from 'react-router-dom';
import useThemeWithPartner from 'hooks/useThemeWithPartner';
import IconConfigWithTheme from 'components/common/icon-config-with-theme';
import useOnClickOutside from 'hooks/useOnClickOutside';
import useConfigTheme from 'hooks/useConfigTheme';

const Style = styled.div`
    label: nav-menu;

    display: flex;
    align-items: center;
    height: 100%;

    ${breakpoint('LG')} {
        display: none;
    }

    .list {
        margin-left: 50px;
        a {
            color: var(--navbar-menu-bar-color);
            font-weight: 600;
            font-size: 1.2rem;
        }
    }
    .service-list-title {
        cursor: pointer;
        margin-left: 50px;
        color: var(--navbar-menu-bar-color);
        font-weight: 600;
        font-size: 1.2rem;
    }
    .menu {
        position: absolute;
        top: 85px;
        /* right: 0; */
        z-index: 10;
        min-width: 200px;
        white-space: nowrap;
        border-radius: 10px;
        padding: 15px 20px;
        background-color: var(--navbar-dropdown-background-color);

        > .list-manu {
            display: grid;
            grid-template-columns: 30px auto;
            color: var(--navbar-dropdown-color-inactive);
            margin: 10px 0;
            cursor: pointer;

            &:hover {
                color: var(--navbar-dropdown-color-active);
            }

            .nav-dropdown-icon {
                color: var(--navbar-dropdown-icon-color);
            }
        }
    }
`;

/**
 *
 * @param {{
 * to: String,
 * className: String,
 * classActive: String,
 * tag: String,
 * } & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>} props
 * @returns
 */
function NavLink({ to = '', className = '', classActive = '', tag = '', children, ...props }) {
    const location = useLocation();

    const getClassName = () => {
        let isActive = false;

        if (location.pathname || (tag && location.pathname.includes(tag))) isActive = true;

        if (className && isActive && classActive) return { className: className + ' ' + classActive };

        if (!className && isActive && classActive) return { className: classActive };

        if (className) return { className };

        return null;
    };

    if (to) {
        return (
            <a href={to} {...props} {...getClassName()}>
                {children}
            </a>
        );
    }
    return <button {...getClassName()}>{children}</button>;
}
function ServiceMenu() {
    const { t } = useTranslation();
    const { configServiceCard } = useConfigTheme();
    const service = configServiceCard;
    let serviceMenuData = [];

    const serviceData = {
        mth: {
            serviceId: 'mthCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'mth' },
            title: 'ปรึกษาจิตแพทย์/นักจิตวิทยาคลินิก',
        },
        tlm: {
            serviceId: 'tlmCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'tlm' },
            title: t('home:telemedicine'),
        },
        tlmNcd: {
            serviceId: 'tlmNCDCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'tlm' },
            title: 'ปรึกษาแพทย์โรคเรื้อรังตอนนี้',
        },
        tlmMtl: {
            serviceId: 'tlmMTLCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'tlm' },
            title: t('home:telemedicine'),
        },
        pt: {
            serviceId: 'ptCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'pt' },
            title: t('home:physiotherapy'),
        },
        nt: {
            serviceId: 'ntCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'nt' },
            title: t('home:nutritionist'),
        },
        telemed: {
            serviceId: 'telemedCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'telemed' },
            title: t('home:telemedicine'),
        },
        telepharmacy: {
            serviceId: 'telepharmacyCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'telepharmacy' },
            title: t('home:telepharmacy'),
        },
        telepharmacyCPA: {
            serviceId: 'telepharmacyCPACard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'telepharmacyLTC' },
            title: 'ร้านยารักษ์ไต',
        },
        telepharmacyLTC: {
            serviceId: 'telepharmacyLTCCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'telepharmacyLTC' },
            title: 'เติมยาโรคเรื้อรัง',
        },
        telepharmacyBoots: {
            serviceId: 'telepharmacyBootsCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'telepharmacy' },
            title: t('home:telepharmacy') + ' Boots',
        },
        telepharmacyTopscare: {
            serviceId: 'telepharmacyTopscareCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'telepharmacy' },
            title: t('home:telepharmacy') + ' Topscare',
        },
        fulfillment: {
            serviceId: 'fulfillmentCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'telepharmacyLTC' },
            title: 'สั่งยาตามใบสั่งแพทย์',
        },
        nearby: {
            serviceId: 'nearbyCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'nearby' },
            title: t('home:pharmacy_directory'),
        },
        fda: {
            serviceId: 'fdaCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'fda' },
            title: t('navbar:menu.pharmacy_directory'),
        },
        atk: {
            serviceId: 'atkCard',
            titleIcon: { type: 'icon', pageName: 'home_service', iconName: 'telepharmacy' },
            title: t('home:purchase_covid_19_antigen_test_kit'),
        },
    };

    service?.forEach((item) => {
        serviceMenuData.push({
            ...item,
            ...serviceData[item.serviceName],
        });
    });
    if (serviceMenuData.length > 0)
        return (
            <>
                {serviceMenuData.map((item, index) => (
                    <a href={item.redirectUrl} className='list-manu' key={index}>
                        <div>
                            <IconConfigWithTheme
                                pageName={item.titleIcon.pageName}
                                iconName={item.titleIcon.iconName}
                                className='nav-dropdown-icon'
                            />
                        </div>
                        <div>{item.title}</div>
                    </a>
                ))}
            </>
        );
    return null;
}
function NavMenuBar({ role }) {
    const { t } = useTranslation();
    const theme = useThemeWithPartner();
    const menuRef = useRef();
    const [showMenu, setShowMenu] = useState(false);

    useOnClickOutside(menuRef, () => setShowMenu(false));

    const getGoHome = (e) => {
        e.preventDefault();

        const params = paramsjs.query()?.voucher ? '?voucher=' + paramsjs.query()?.voucher : '';

        if (theme.name === 'betterperiod') return '#';
        if (theme.name === 'bilaxten') return window.location.assign('/activities');

        return window.location.assign('/' + params);
    };

    if (role === 'ROLE_WRITER') {
        return (
            <Style data-test-id='menu'>
                <div className='list'>
                    <NavLink to='/article-management'>{t('navbar:menu.article')}</NavLink>
                </div>
            </Style>
        );
    }

    if (role === 'ROLE_ADMIN') {
        return (
            <Style data-test-id='menu'>
                <div className='list'>
                    <NavLink to='/' onClick={getGoHome}>
                        {t('navbar:menu.homepage')}
                    </NavLink>
                </div>
                {theme.name === 'default' && (
                    <div className='service-list'>
                        <div className='service-list-title' onClick={() => setShowMenu(!showMenu)}>
                            {t('navbar:menu.our_services')} &nbsp;
                            <IconConfigWithTheme pageName='nav_profile' iconName='profile_menu' className='nav-dropdown-icon' />
                        </div>
                        <div ref={menuRef} className='menu' style={{ display: showMenu ? 'block' : 'none' }}>
                            <ServiceMenu />
                        </div>
                    </div>
                )}
                <div className='list'>
                    <NavLink to='/article-management'>{t('navbar:menu.article')}</NavLink>
                </div>
            </Style>
        );
    }

    return (
        <Style data-test-id='menu'>
            <div className='list'>
                <NavLink to='/' onClick={getGoHome}>
                    {t('navbar:menu.homepage')}
                </NavLink>
            </div>
            {theme.name === 'default' && (
                <>
                    <div className='service-list'>
                        <div className='service-list-title' onClick={() => setShowMenu(!showMenu)}>
                            {t('navbar:menu.our_services')} &nbsp;
                            <IconConfigWithTheme pageName='nav_profile' iconName='profile_menu' className='nav-dropdown-icon' />
                        </div>
                        <div ref={menuRef} className='menu' style={{ display: showMenu ? 'block' : 'none' }}>
                            <ServiceMenu />
                        </div>
                    </div>
                    <div className='list'>
                        <NavLink to='/article'>{t('navbar:menu.article')}</NavLink>
                    </div>
                </>
            )}
        </Style>
    );
}

export default NavMenuBar;
